// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBZQCzlris2RXkDweXFFsapnH1DZNS1WD4",
  authDomain: "shitalpaints-3ef23.firebaseapp.com",
  projectId: "shitalpaints-3ef23",
  storageBucket: "shitalpaints-3ef23.firebasestorage.app",
  messagingSenderId: "606570640303",
  appId: "1:606570640303:web:6e9dab627fd143b589b55a",
  measurementId: "G-H0NY31LCH7"
};
export {firebaseConfig}
// Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

// export const auth = getAuth();
// export default app;